import { LowerCasePipe, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { AnalyticsService } from 'src/app/core/services/analytics/analytics.service';
import { LOYALTY_BADGES } from 'src/app/shared/components/loyalty-badge/constants/loyalty-badges';
import {
  LoyaltyBadgeSize,
  LoyaltyBadgeType,
  LoyaltyBadgeVariant,
} from 'src/app/shared/components/loyalty-badge/types/loyalty-badge.type';
import { LoyaltyBadgeModalComponent } from './loyalty-badge-modal/loyalty-badge-modal.component';

@Component({
  selector: 'app-loyalty-badge',
  standalone: true,
  templateUrl: './loyalty-badge.component.html',
  styleUrls: ['./loyalty-badge.component.scss'],
  imports: [NgClass, NgIf, LowerCasePipe, IonicModule, LoyaltyBadgeModalComponent],
})
export class LoyaltyBadgeComponent {
  @Input() set level(level: keyof typeof LOYALTY_BADGES) {
    const levels = Object.keys(LOYALTY_BADGES);
    if (level && levels.includes(level)) {
      this.badge = LOYALTY_BADGES[level];
    }
  }

  @Input() size: LoyaltyBadgeSize = 'large';

  @Input() variant: LoyaltyBadgeVariant = 'full';

  @Input() ariaLabel: string | null = null;

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  badge: LoyaltyBadgeType;

  isModalOpen = false;

  constructor(private readonly analyticsService: AnalyticsService) {}

  openModal(): void {
    this.isModalOpen = true;
    this.analyticsService.clicked({
      object_type: 'Button',
      object_target: 'Loyalty Badge',
      loyalty_badge: this.badge.name,
    });
    this.onClick.emit();
  }

  dismissModal(): void {
    this.isModalOpen = false;
  }
}
